import * as types from '../constants/bookingConstants';
import * as coreTypes from '../../core/constants/coreConstants';
import * as api from '../../api/api';
import { getLastSavedRoute } from '../../util/routeHelper';
import { browserHistory } from 'react-router';


export function getBookingSuccess(bookingData) {
	return {
		type: types.GET_BOOKING_DATA_SUCCESS,
		response: bookingData
	};
}

export function getBookingAvailableDaysSuccess(availabledays) {
	return {
		type: types.GET_BOOKING_AVAILABILITY_SUCCESS,
		response: availabledays
	};
}

export function notFound() {
	return {
		type: types.JOBID_NOT_FOUND
	};
}

export function changeUIState() {
	return {
		type: coreTypes.UPDATE_UI_STATE,
		response: coreTypes.UI_STATES.BOOKING_COMPLETED
	};
}

export function confirmBookingError(error) {
	return {
		type: types.CONFIRM_BOOKING_ERROR,
		response: error
	};
}

export function apiCallInProgress(status) {
	return {
		type: types.API_CALL_INPROGRESS,
		response: status
	};
}

export function clearErrors() {
	return function (dispatch) {
		dispatch(confirmBookingError(null));
	};
}

export function getBookingDetails(jobId) {
	return function (dispatch) {
		dispatch(apiCallInProgress(true));
		api.get("booking/".concat(jobId).concat("/merchantinfo"))
			.then(function (response) {
				dispatch(getBookingSuccess(response));
				dispatch(apiCallInProgress(false));
			}).catch(function (error) {
				// dispatch(notFound());
				browserHistory.push('/contactus/error/'.concat(jobId));
			});
	};
}

export function goToUpdateAddress(jobId) {
	return function () {
		browserHistory.push(`/address/${jobId}/edit`);
	};
}

export function goToAddAddress(jobId) {
	return function() {
		browserHistory.push(`/address/${jobId}/add`);
	};
}

export function goToUpdateContacts(jobId) {
	return function() {
		browserHistory.push(`/address/${jobId}/editcontact`);
	};
}

export function goBackToSavedRoute() {
	return function() {
		browserHistory.push(getLastSavedRoute());
	};
}

export function getBookingAvailableDays(jobId) {
	return function (dispatch) {
		dispatch(apiCallInProgress(true));
		api.get("booking/".concat(jobId).concat("/availability"))
			.then(function (response) {
				dispatch(getBookingAvailableDaysSuccess(response));
				dispatch(apiCallInProgress(false));
			}).catch(function () {

				browserHistory.push('/contactus/error/'.concat(jobId));
			});
	};
}


export function confirmBooking(jobId, values) {
	return function (dispatch) {

		dispatch(apiCallInProgress(true));
		values.jobId = jobId;

		api.post("booking/confirm", values).
			then(function () {
				dispatch(getBookingDetails(jobId));
				dispatch(changeUIState());
				browserHistory.push('/booking/'.concat(jobId));
			}).catch(function (error) {
				dispatch(confirmBookingError(error));
				dispatch(apiCallInProgress(false));
				browserHistory.push('/contactus/error/'.concat(jobId));
			});
	};
}


export function getJobInfoSuccess(jobData) {
  return {
    type: types.GET_JOB_DATA_SUCCESS,
    response: jobData
  };
}

export function getJobInfo(jobId) {
  return function (dispatch) {
    dispatch(apiCallInProgress(true));
    api.get("jobs/".concat(jobId).concat("/jobinfo"))
      .then(function (response) {
        dispatch(getJobInfoSuccess(response));
        dispatch(apiCallInProgress(false));
      }).catch(function (error) {
        // dispatch(notFound());
        browserHistory.push('/contactus/error/'.concat(jobId));
      });
  };
}



// WEBPACK FOOTER //
// ./app/booking/actions/bookingActions.js